// extracted by css-extract-rspack-plugin
export default {"colorRedTint":"#f4e2e6","colorRed":"#ea3556","errorBox":"number-input__errorBox___StiN7"};